/* eslint-disable camelcase */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSnapshot } from 'valtio';

import { refsStore } from '../managers/globalState';

import '../../www/assets/css/latest_event.css';


const LatestEvent = ({ title, external_id }) => {
	const { get } = useSnapshot(refsStore.state);

	const clickHandle = useCallback(() => {
		const routeManager = get('route');
		routeManager.goToEvent(external_id);
	}, [get, external_id]);

	const text = `آخر كارثة طبيعية : ${title} `;

	return (
		<div className='latest-event-container d-flex justify-content-center' onClick={clickHandle}>
			<h3 className='latest-event'>{text}</h3>
		</div>
	);
};

LatestEvent.propTypes = {
	title: PropTypes.string.isRequired,
	external_id: PropTypes.string.isRequired
};

export default LatestEvent;
